import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DropDownOption } from '@app/core/interfaces/common/form.interface';
import { Currency } from '@app/core/interfaces/model/custodian.interface';
import { Instrument, InstrumentListResponse } from '@app/core/interfaces/model/instrument.interface';
import { environment } from '@env/environment';
import {map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InstrumentService {
  apiURL =  `${environment.apiEndpoint}/admin/instruments`;

  constructor(private http: HttpClient) { }


    search(fundId: number, query: string): Observable<DropDownOption[]> {
      const url = query ? `${this.apiURL}/fund/${fundId}/search?query=${query}` : `${this.apiURL}/fund/${fundId}/search`;
      return this.http.get<InstrumentListResponse[]>(url).pipe(
        map((instruments) => {
            if (instruments.length > 0) {
              return instruments.map(item => {
                return {
                  name: item.name,
                  value: item
                }
            })
            } else {
              return [];
            }
        }
      ));
    }

    getAll(): Observable<Instrument[]> {
      const url = this.apiURL;
      return this.http.get<Instrument[]>(url);
    }


    getByFundId(fundId: number): Observable<InstrumentListResponse[]> {
        const url = `${this.apiURL}/fund/${fundId}`;
        return this.http.get<InstrumentListResponse[]>(url);
    }


    editInstrument(instrument: Instrument): Observable<any> {
      const url = `${this.apiURL}/${instrument.id}`
      return this.http.put<any>(url, instrument);
    }

    addInstrument(instrument: any): Observable<any> {
      return this.http.post<any>(this.apiURL, instrument);
    }

    delete(id: number): Observable<any> {
      const url = `${this.apiURL}/${id}`
      return this.http.delete<any>(url);
    }

    getCurrencies(query?: string): Observable<Currency[]> {
        const url = query ? `${environment.apiEndpoint}/admin/currencies?query=${query}` : `${environment.apiEndpoint}/admin/currencies`;
        return this.http.get<any[]>(url)
    }
}
